$(document).ready(function() {
  if (window.location.href.indexOf("search") != -1) {
    if (window.location.href.indexOf("search-query") == -1) {
      let params = new URL(document.location).searchParams;
      let query = params.get("q");

      document.getElementById("searchBox").className += " show";
      document.getElementById("search").placeholder = query;
    }
    if (window.location.href.indexOf("search-query") != -1) {
      let params = new URL(document.location).searchParams;
      let query = params.get("query");
      $("#search-hilfe")
        .val(query)
        .trigger("keyup");
    }
  }
});  


// WEBPACK FOOTER //
// ./source/assets/js/modules/search-input-field.js